"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
var abs = Math.abs;
var Vector = /** @class */ (function () {
    function Vector(x, y) {
        this.x = x;
        this.y = y;
        if (isNaN(x) || isNaN(y)) {
            throw new Error("Creating vector with NaN: " + this);
        }
        Object.freeze(this);
    }
    Vector.of = function (x, y) {
        return new Vector(x, y);
    };
    Vector.from = function (_a) {
        var _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c;
        return new Vector(x, y);
    };
    Vector.fromRandom = function (minOrMax, max) {
        return new Vector(util_1.random(minOrMax, max), util_1.random(minOrMax, max));
    };
    Vector.apply = function (action) {
        var vectors = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            vectors[_i - 1] = arguments[_i];
        }
        return Vector.of(action.apply(void 0, vectors.map(function (vector) { return vector.x; })), action.apply(void 0, vectors.map(function (vector) { return vector.y; })));
    };
    Vector.range = function (_a) {
        var _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c;
        return this.iterate(Vector.of(x, y));
    };
    Vector.average = function (list) {
        return list.reduce(function (sum, vector) { return sum.add(vector); }).vdiv(list.length);
    };
    Vector.iterate = function (vectorA, vectorB) {
        var start, end, x, y;
        if (vectorB === void 0) { vectorB = new Vector(0, 0); }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    start = this.apply(Math.min, vectorA, vectorB);
                    end = this.apply(Math.max, vectorA, vectorB);
                    x = start.x;
                    _a.label = 1;
                case 1:
                    if (!(x < end.x)) return [3 /*break*/, 6];
                    y = start.y;
                    _a.label = 2;
                case 2:
                    if (!(y < end.y)) return [3 /*break*/, 5];
                    return [4 /*yield*/, start.add({ x: x, y: y })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    y++;
                    return [3 /*break*/, 2];
                case 5:
                    x++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/];
            }
        });
    };
    Object.defineProperty(Vector.prototype, "isZero", {
        get: function () {
            return this.x === 0 && this.y === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "magnitude", {
        get: function () {
            if (this.isZero) {
                return 0;
            }
            if (!this._magnitude) {
                this._magnitude = Math.hypot(this.x, this.y);
            }
            return this._magnitude;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "radians", {
        get: function () {
            if (this.isZero) {
                return 0;
            }
            var _a = this, x = _a.x, y = _a.y;
            var arctan = Math.atan(y / x);
            if (arctan < 0) {
                arctan += Math.PI;
            }
            if (y < 0 || (y === 0 && x < 0)) {
                arctan += Math.PI;
            }
            return arctan;
        },
        enumerable: true,
        configurable: true
    });
    Vector.prototype.setX = function (value) {
        return Vector.of(value, this.y);
    };
    Vector.prototype.setY = function (value) {
        return Vector.of(this.x, value);
    };
    Vector.prototype.setMagnitude = function (value) {
        if (this.magnitude === 0) {
            return Vector.of(value, 0);
        }
        var ratio = this.magnitude / value;
        return Vector.of(this.x / ratio, this.y / ratio);
    };
    Vector.prototype.diff = function (_a) {
        var _b = _a.x, x = _b === void 0 ? this.x : _b, _c = _a.y, y = _c === void 0 ? this.y : _c;
        return Vector.of(abs(this.x / x), abs(this.y / y));
    };
    Vector.prototype.distance = function (target) {
        return this.sub(target).magnitude;
    };
    Vector.prototype.is = function (_a) {
        var _b = _a.x, x = _b === void 0 ? this.x : _b, _c = _a.y, y = _c === void 0 ? this.y : _c;
        return this.x === x && this.y === y;
    };
    Vector.prototype.vis = function (_a) {
        var _b = _a.x, x = _b === void 0 ? this.x : _b, _c = _a.y, y = _c === void 0 ? this.y : _c;
        return this.x === x && this.y === y;
    };
    Vector.prototype.sub = function (_a) {
        var _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c;
        return Vector.of(this.x - x, this.y - y);
    };
    Vector.prototype.vsub = function (value) {
        return Vector.of(this.x - value, this.y - value);
    };
    Vector.prototype.add = function (_a) {
        var _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c;
        return Vector.of(this.x + x, this.y + y);
    };
    Vector.prototype.vadd = function (value) {
        return Vector.of(this.x + value, this.y + value);
    };
    Vector.prototype.mul = function (_a) {
        var _b = _a.x, x = _b === void 0 ? 1 : _b, _c = _a.y, y = _c === void 0 ? 1 : _c;
        return Vector.of(this.x * x, this.y * y);
    };
    Vector.prototype.vmul = function (value) {
        return Vector.of(this.x * value, this.y * value);
    };
    Vector.prototype.div = function (_a) {
        var _b = _a.x, x = _b === void 0 ? 1 : _b, _c = _a.y, y = _c === void 0 ? 1 : _c;
        return Vector.of(this.x / x, this.y / y);
    };
    Vector.prototype.vdiv = function (value) {
        return Vector.of(this.x / value, this.y / value);
    };
    Vector.prototype.toString = function () {
        return "[Vector(" + this.x + ", " + this.y + ")]";
    };
    Vector.prototype.toJSON = function () {
        return {
            $type: 'vector',
            x: this.x,
            y: this.y,
        };
    };
    Vector.ZERO = Vector.of(0, 0);
    return Vector;
}());
exports.default = Vector;
